import React, { ReactNode } from 'react';
import {
  CardWrapper,
  Header,
  TextInfo,
  Title,
  ButtonWrapper,
  ButtonContainer,
} from './style';
import { Button, StatusBadge } from 'react-covideo-common';
import { MdEdit } from 'react-icons/md';
import { useIsMutating } from 'react-query';
import { useCDK } from 'lib/hooks/useCdk';
import { useTranslation } from 'react-i18next';

interface IDeletionCard {
  icon: ReactNode;
  title: string;
  isActive: boolean;
  isEdit?: boolean;
  textInfo: string;
  activateFn?: () => void;
  deactivateFn?: () => void;
  editFn?: () => void;
  activateText: string;
  deactivateText: string;
}

const Card = ({
  icon,
  title,
  isActive,
  isEdit,
  textInfo,
  activateFn,
  deactivateFn,
  editFn,
  activateText,
  deactivateText,
}: IDeletionCard) => {
  const { destructiveToSecondary } = useCDK();
  const { t } = useTranslation();
  const isMutating = useIsMutating();
  const isDisabled = isMutating > 0;
  return (
    <CardWrapper>
      <Header>
        {icon}
        <Title>{title}</Title>
        <StatusBadge
          text={isActive ? t('Active') : t('Inactive')}
          variant={isActive ? 'success' : 'error'}
        />
      </Header>
      <TextInfo>{textInfo}</TextInfo>
      <ButtonContainer>
        {isEdit && (
          <ButtonWrapper>
            <Button
              icon={<MdEdit size={15} />}
              onClick={editFn}
              variant='secondary'
              text={t('Edit')}
              size='small'
              disabled={isDisabled}
            />
          </ButtonWrapper>
        )}
        {!isActive ? (
          <ButtonWrapper>
            <Button
              variant='secondary'
              onClick={activateFn}
              text={activateText}
              size='small'
              disabled={isDisabled}
            />
          </ButtonWrapper>
        ) : (
          <ButtonWrapper>
            <Button
              variant={destructiveToSecondary}
              size='small'
              text={deactivateText}
              onClick={deactivateFn}
              disabled={isDisabled}
            />
          </ButtonWrapper>
        )}
      </ButtonContainer>
    </CardWrapper>
  );
};

export { Card };
